import React from "react";
import { SITE_ASSETS } from "../mock";

export default function InspirationsSection() {
  const imgs = SITE_ASSETS.inspirations;
  return (
    <section className="py-28 lg:py-36 bg-[#F5EFE6] relative">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
          <div>
            <div className="section-eyebrow mb-4">Our Inspirations</div>
            <h2 className="section-title font-display">Materials, Light, <span className="italic text-[#B8893C]">Restraint</span>.</h2>
          </div>
          <p className="max-w-md text-[#3a322a] leading-relaxed">
            A glimpse into the textures and moments that shape every Tamra address — from polished marble lobbies to sky-level wellness retreats.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {imgs.map((src, i) => (
            <div
              key={i}
              className={`overflow-hidden ${i === 0 ? "col-span-2 row-span-2 aspect-[1/1]" : "aspect-[4/5]"}`}
            >
              <img src={src} alt={`inspiration-${i}`} className="w-full h-full object-cover img-hover" />
            </div>
          ))}
        </div>
      </div>

      {/* Marquee */}
      <div className="mt-24 overflow-hidden border-y border-[#EBE0CE] py-6">
        <div className="marquee-track flex whitespace-nowrap">
          {Array.from({ length: 2 }).map((_, k) => (
            <div key={k} className="flex items-center gap-12 pr-12">
              {["Crafted Skylines", "Curated Materials", "Considered Light", "Lasting Architecture", "Quiet Luxury", "Tamra Developers"].map((w, idx) => (
                <span key={idx} className="font-display text-3xl md:text-5xl tracking-[0.18em] text-[#5C2018]">
                  {w} <span className="text-[#B8893C] mx-6">·</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
